// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import previewImageHelper from '../../../../application/helpers/previewImageHelper';

export default class EditView extends JQueryView {
  cloneFileElement = {};

  constructor() {
    super('.simple_form');
    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
    }
  }

  @on({ event: 'click', selector: '.upload-image' })
  chooseImage() {
    $('.choose-image').click();
  }

  @on({ event: 'change', selector: '.choose-image' })
  changeImage(event: any) {
    const fileElement = event.currentTarget;
    const sizeLimit = 1024 * 1024 * 5;
    if (fileElement.files[0] && fileElement.files[0].size > sizeLimit) {
      alert('画像を5MB以下のサイズにしてください');
      fileElement.value = '';
      return;
    }
    if (fileElement.value === '') {
      fileElement.parentElement.append(this.cloneFileElement[fileElement.id]);
      fileElement.remove();
    } else {
      previewImageHelper($('.choose-image'), $('.image-tag'));
      $('.logo-delete-btn-svg').removeClass('d-none');
      $('#remove_image').val('false');
    }
  }

  @on({ event: 'click', selector: '.choose-image' })
  keepPreviousImage(event: any) {
    const fileElement = event.currentTarget;
    if (fileElement.value !== '') {
      this.cloneFileElement[fileElement.id] = fileElement.cloneNode(true);
    }
  }

  @on({ event: 'click', selector: '.logo-delete-btn' })
  deleteImage() {
    $('#remove_image').val('true');
    $('.image-tag').attr('src', $('.image-tag-hidden').attr('src'));
    $('.choose-image').val('');
    $('.logo-delete-btn-svg').addClass('d-none');
  }
}
